import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

const formatInt = (n) => {
  const num = Number(n);
  if (!Number.isFinite(num)) return '';
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Math.trunc(num));
};

const getOrdinalSuffix = (n) => {
  const num = Math.abs(Number(n));
  if (!Number.isFinite(num)) return '';
  const mod100 = num % 100;
  if (mod100 >= 11 && mod100 <= 13) return 'th';
  const mod10 = num % 10;
  if (mod10 === 1) return 'st';
  if (mod10 === 2) return 'nd';
  if (mod10 === 3) return 'rd';
  return 'th';
};

const toOrdinal = (n) => {
  const num = Number(n);
  if (!Number.isFinite(num) || num <= 0) return '';
  return `${formatInt(num)}${getOrdinalSuffix(num)}`;
};

/**
 * Transforms the traffic_popularity criteria from WooRank API response.
 * We render two lines: World rank and TLD rank (e.g. ".com").
 *
 * @param {Object} trafficPopularityCriteria - criteria.traffic_popularity
 * @returns {Object} transformed criteria
 */
export const transformTrafficRank = (trafficPopularityCriteria) => {
  if (!trafficPopularityCriteria) {
    return {
      status: 'error',
      iconType: 'error',
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No Traffic Rank was not able to be generated.',
      data: null,
    };
  }

  const wooRankStatus = trafficPopularityCriteria?.status || 'neutral';
  const importance = trafficPopularityCriteria?.importance || 0;
  const solvability = trafficPopularityCriteria?.solvability || 0;

  const globalRank = Number(trafficPopularityCriteria?.data?.globalRank || 0);
  const tldRank = Number(trafficPopularityCriteria?.data?.tldRank || 0);
  const tld = String(trafficPopularityCriteria?.data?.tld || '').trim();

  const globalOrdinal = toOrdinal(globalRank);
  const tldOrdinal = toOrdinal(tldRank);
  const tldLabel = tld ? `.${tld}` : '';

  const isEmpty = !globalOrdinal && !tldOrdinal;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: isEmpty ? 'No Traffic Rank was not able to be generated.' : null,
    data: isEmpty
      ? null
      : {
          globalOrdinal,
          tldOrdinal,
          tldLabel,
        },
  };
};

export default transformTrafficRank;


